import ScratchBlockSvgFilters from 'components/Project/Project/ScratchBlockSvgFilters/ScratchBlockSvgFilters'
import HtmlHead from 'components/shared/HtmlHead/HtmlHead'
import {
  displayAllHints,
  displayAllIngredients,
  resizeScratchblocks,
} from 'helpers/Printout'
import { themeClassName } from 'helpers/Project'
import {
  initPrismSyntaxHighlighting,
  removeScratchPreviewIframes,
} from 'helpers/Step'
import { renderMakecodeBlocks } from 'helpers/makecode'
import { scratchblocksInit } from 'helpers/scratchblocks'
import PropTypes from 'prop-types'
import { PrintOnly } from 'components/shared/PrintOnly/PrintOnly'
import React, { Component } from 'react'

import Content from './Content/Content'
import Footer from './Footer/Footer'
import Header from './Header/Header'
import './Printout.scss'

class Printout extends Component {
  componentDidMount() {
    scratchblocksInit(this.props.project, this.props.locale)
    renderMakecodeBlocks()
    initPrismSyntaxHighlighting()
    removeScratchPreviewIframes()
    displayAllHints()
    displayAllIngredients()
    resizeScratchblocks()
  }

  render() {
    return (
      <PrintOnly>
        <ScratchBlockSvgFilters />
        <HtmlHead title={this.props.project.title} />
        <div className={themeClassName(this.props.project.theme)}>
          <Header locale={this.props.locale} project={this.props.project} />
          <Content
            steps={this.props.project.steps}
            theme={this.props.project.theme}
          />
          <Footer slug={this.props.slug} />
        </div>
      </PrintOnly>
    )
  }
}

Printout.propTypes = {
  locale: PropTypes.string.isRequired,
  project: PropTypes.object.isRequired,
  slug: PropTypes.string.isRequired,
}

export default Printout
